<admin-page-tab-section>
  <admin-panel-empty>
    <admin-accordion-nice [items]="rules!">
      <ng-template #first let-item let-index="index" let-refid="refid">
        <admin-channels-rule-header [rule]="item" class="row" style="width: 100%"/>
      </ng-template>
      <ng-template #second let-item>
        <admin-panel-inner>
          <admin-channels-rule-details [rule]="item" [title]="'Rule'"/>
        </admin-panel-inner>
      </ng-template>
    </admin-accordion-nice>
  </admin-panel-empty>
</admin-page-tab-section>
